const categories = {
    restaurants: {
        name: "Restaurants",
        title: "votre table préféré à prix malin 🥘",
        description: "Restaurants locaux, fast-food, pizzeria ...",
        to : '/restaurants',
    },
    activity: {
        name: "Activités",
        title: "Amusez-vous sans vous priver 👨‍👩‍👧‍👦",
        description: "En famille, entre amis ...",
        to : '/activities',
    },
    beauty: {
        name: "Bien être",
        title: "La détente avec moins de dépense 🌸",
        description: "Spa, soin du corps, coiﬀure ...",
        to : '/beauty',
    },
    cars: {
        name: "Service auto",
        title: "Roulez en toute sécurité, à prix malin 🚗",
        description: "Garages, stations-service, spécialistes auto ...",
        to : '/cars',
    },
    alimentation: {
        name: "Epicerie",
        title: "L’épicerie qui a du gout et du sens 🍎",
        description: "Épiceries, boucherie, boulangeries et marchés locaux à découvrir.",
        to : '/alimentation',
    },
};

export default categories;